import React, { FC, useEffect, useState } from 'react';
import { Input } from '@duxton-web/ui';

import './TableSearch.css';

interface ITableSearchProps {
  value?: string;
  placeholder?: string;
  searchWidth?: string | number;
  loading?: boolean;
  onSearch: (value: string) => void;
}

const TableSearch: FC<ITableSearchProps> = ({
  value,
  placeholder,
  searchWidth = '350px',
  loading = false,
  onSearch,
}) => {
  const [searchValue, setSearchValue] = useState<string>('');

  useEffect(() => {
    setSearchValue(value);
  }, [value]);

  const handleSearch = () => {
    onSearch(searchValue);
  };

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newValue = e.target.value;
    setSearchValue(newValue);

    // Trigger search immediately when input is cleared
    if (newValue === '') {
      onSearch('');
    }
  };

  return (
    <Input.Search
      className="table-search"
      data-testid="tableSearch-search"
      style={{
        width: searchWidth,
      }}
      disabled={loading}
      loading={loading}
      placeholder={placeholder || 'Search by name and description'}
      enterButton
      allowClear={true}
      value={searchValue}
      onChange={handleChange}
      onSearch={handleSearch}
    />
  );
};

export default TableSearch;
